import Keycloak from "keycloak-js";

    const keycloak = Keycloak(
        `/${process.env.REACT_APP_KEYCLOAK_FILENAME || "keycloak.json"}`
      );

export default keycloak;